import message from 'owa-service/lib/factory/message';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import setItemField from 'owa-service/lib/factory/setItemField';
export default function createSetItemField(propertyUriStr, value) {
    var _a;
    return setItemField({
        Path: propertyUri({ FieldURI: propertyUriStr }),
        Item: message((_a = {}, _a[propertyUriStr] = value, _a)),
    });
}
//# sourceMappingURL=createSetItemField.js.map